import Vue from 'vue'
import App from '@/App'

export default ({ debug, router, store, VueI18N }) => {
  debug && console.log('bootstrap.app', 'init');
  
  return new Promise((resolve) => {
    new Vue({
      router,
      store,
      i18n: VueI18N.i18n,
      render: h => h(App)
    }).$mount('#app');

    debug && console.log('bootstrap.app', 'completed');
    resolve();
  })

}
